
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const PublicRoutes = () => {

  const authToken = sessionStorage.getItem("authToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (authToken ) {
      navigate(-1); // Go back to the previous page
    }
  }, [authToken, navigate]);

  return <Outlet />;
};

export default PublicRoutes;
